export default __webpack_public_path__ + "static/media/why-us.979af173.svg";